export const PIXEL_GLYPH_FORMAT_DESCRIPTION = '9x9 pixels with 3 colors or 20x20 pixels with 5 colors';
function hasValidColors(colors, expectedCount) {
    return Array.isArray(colors)
        && colors.length === expectedCount
        && colors.every((color) => typeof color === 'string' && color.length > 0);
}
function hasValidRows(rows, expectedSize, pixels) {
    return Array.isArray(rows)
        && rows.length === expectedSize
        && rows.every((row) => typeof row === 'string'
            && row.length === expectedSize
            && pixels.test(row));
}
/** Runtime boundary for the two supported authored pixel-glyph formats. */
export function isPixelGlyph(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return false;
    const glyph = value;
    return (hasValidColors(glyph.colors, 3)
        && hasValidRows(glyph.rows, 9, /^[.123]+$/u)) || (hasValidColors(glyph.colors, 5)
        && hasValidRows(glyph.rows, 20, /^[.12345]+$/u));
}
//# sourceMappingURL=pixel-glyph.js.map